import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export function EmptyState({
  title,
  description,
  action,
  icon: Icon,
  illustration,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: LucideIcon;
  illustration?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center rounded-lg border border-dashed px-6 py-12 text-center animate-in fade-in-0 duration-300">
      {illustration ? (
        <div className="mb-4">{illustration}</div>
      ) : (
        Icon && (
          <span className="mb-4 grid h-12 w-12 place-items-center rounded-full bg-primary/10 text-primary ring-8 ring-primary/5">
            <Icon className="h-6 w-6" aria-hidden />
          </span>
        )
      )}
      <p className="font-medium">{title}</p>
      {description && (
        <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
